/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
//material
import Sticky from 'material/structure/sticky/sticky';
import PreviewCTAs from 'pages/dashboard/reports/reportcontrols/variations/preview/previewCTAs';
import DetailCTAs from 'pages/dashboard/reports/reportcontrols/variations/detail/detailCTAs';

//utils
import { generateRunReportParamString } from 'utils/fetchContentHelpers';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/reportcontrols/reportcontrols_styles';



/* ========== ~~~~~~~~~~ REPORT CONTROLS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ReportControls = props => {

    const transpileDataForRMS = (data,returnType) => {
        data.accountUUID = props.accountUUID;
        data.returnType = returnType;
        return generateRunReportParamString(data);
    };

    const transpileEmailToList = emails => {
        let newEmails = [];
        emails.forEach((obj) => {
            if (obj.value && obj.value.length > 0)
                newEmails.push(obj.value);
        });
        return newEmails;
    };

    const transpileDataForPPA = data => ({
        accountUUID: props.accountUUID,
        name: data.name,
        dateRange: data.dateRange,
        dimensions: data.dimensions,
        sites: data.sites,
        devices: data.devices,
        countries: data.countries,
        viewType: data.viewType,
        metrics: data.metrics,
        schedule: data.schedule === 'ONCE' ? null : data.schedule,
        emails: transpileEmailToList(data.emails),
        endDate: data.endDate,
        customDateRange: data.dateRange === 'CUSTOM' ? data.customDateRange : null
    });

    const saveEditSuccess = () => {
        props.getClientReportsData(props.accountUUID);
    };

    const handleSave = () => {
        const PPAData = transpileDataForPPA(props.selectedReportData);
        if (props.selectedReportData.reportUUID) {
            PPAData.accountUUID = null;
            props.updateReport(props.selectedReportData.reportUUID, PPAData, saveEditSuccess)
        } else {
            props.saveReport(PPAData, saveEditSuccess)
        }
    };

    const downloadCSV = () => props.downloadReport(transpileDataForRMS(props.selectedReportData, 'CSV'), 'CSV');

    const downloadXLSX = () => props.downloadReport(transpileDataForRMS(props.selectedReportData, 'XLSX'), 'XLSX');

    const runReport = () => {
        props.runReport(transpileDataForRMS(props.selectedReportData, 'JSON'), () => props.moveToPage('dashboard/reports/preview'))
    };

    const handleRunAndSave = () => {
        props.saveAndRunReport(transpileDataForPPA(props.selectedReportData), props.selectedReportData.reportUUID, props.accountUUID);
        //replicated this so I can remove the success route on save and route to preview after run instead
        // let PPAData = transpileDataForPPA(props.selectedReportData);
        // if (props.selectedReportData.reportUUID) {
        //     PPAData.accountUUID = null;
        //     props.updateReport(props.selectedReportData.reportUUID, PPAData, () => props.getClientReportsData(props.accountUUID))
        // } else {
        //     props.saveReport(PPAData, () => props.getClientReportsData(props.accountUUID))
        // }
        // props.runReport(transpileDataForRMS(props.selectedReportData), () => props.moveToPage('dashboard/reports/preview'))
    };

    const renderControls = variant => {
        switch (variant) {
            case 'preview':
              return <PreviewCTAs
                    handleSave={handleSave}
                    downloadCSV={downloadCSV}
                    downloadExcel={downloadXLSX}
                    currentPage={props.currentPage}
                    saveReportPending={props.saveReportPending}
                    reportDownloading={props.reportDownloading}
                    isReportSaved={props.isReportSaved}
                />;
            case 'detail':
            default:
                return <DetailCTAs
                    navigateInvalid={() => props.navigateInvalid()}
                    handleRun={runReport}
                    handleSave={handleSave}
                    handleRunAndSave={handleRunAndSave}
                    currentPage={props.currentPage}
                    saveReportPending={props.saveReportPending}
                    isReportSaved={props.isReportSaved}
                    reportChangeDetected={props.reportChangeDetected}
                    running={props.reportRunning}
                    discardReportChanges={props.discardReportChanges}
                />
        }
    };
    return (
        <Sticky>
            {renderControls(props.variant)}
        </Sticky>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportControls);
